var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-content"},[_c('div',{staticClass:"app-title"},[_c('div',[_c('h1',[_c('font-awesome-icon',{attrs:{"icon":"link"}}),_vm._v("\n          Webhook Vietguys\n        ")],1)])]),_c('webhook-vietguys-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }